import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  MutableValidated2ognu5vxf17ur as MutableValidated,
  MutableValidatedValuegls7jkstsdwb as MutableValidatedValue,
  lensi9s8q1zaykbw as lens,
  lens2dr2mfn274h1a as lens_0,
  lens2gvfhjoqnpofs as lens_1,
  lens2wuprihu5z787 as lens_2,
} from './Validated.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  MutableReactiveValue$_get_value_$ref_6a9vml34vdn15gbmoj8 as MutableReactiveValue$_get_value_$ref_6a9vml,
  MutableReactiveValue$_set_value_$ref_n0kkrzla8i7c48thns as MutableReactiveValue$_set_value_$ref_n0kkrz,
  valueSet3cf2hvvu95f3 as valueSet,
  set3ct43wkzm94lj as set,
  Reactive1jy75v4li6ldv as Reactive,
  get_state389x218zizu8a as get_state,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Listenable3m4zqvjcbvczy as Listenable,
} from '../../core/coreInterfaces.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from './IssueNode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function validated(_this__u8e3s4, reportTo) {
  reportTo = reportTo === VOID ? null : reportTo;
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, MutableValidated()) ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? new (RootMutableValidated())(_this__u8e3s4, reportTo) : tmp0_elvis_lhs;
}
function validated_0(_this__u8e3s4, reportTo) {
  reportTo = reportTo === VOID ? null : reportTo;
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, MutableValidatedValue()) ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? new (RootMutableValidatedValue())(_this__u8e3s4, reportTo) : tmp0_elvis_lhs;
}
var RootMutableValidatedClass;
function RootMutableValidated() {
  if (RootMutableValidatedClass === VOID) {
    class $ extends RootValidated() {
      constructor(wrapped, reportTo) {
        super(wrapped, reportTo);
        this.wrapped_2 = wrapped;
      }
      *set_revjhg_k$(value, $completion) {
        return yield* this.wrapped_2.set_revjhg_k$(value, $completion);
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'RootMutableValidated', VOID, VOID, [MutableValidated()], [1]);
    RootMutableValidatedClass = $;
  }
  return RootMutableValidatedClass;
}
function RootMutableValidatedValue$_get_value_$ref_9j9rny() {
  return constructCallableReference((p0) => p0.get_value_j01efc_k$(), 1, 0, 11);
}
function RootMutableValidatedValue$_set_value_$ref_w6ztwm() {
  return constructCallableReference((p0, p1) => {
    p0.set_value_v1vabv_k$(p1);
    return Unit_instance;
  }, 2, 0, 12);
}
var RootMutableValidatedValueClass;
function RootMutableValidatedValue() {
  if (RootMutableValidatedValueClass === VOID) {
    class $ extends RootValidatedValue() {
      constructor(wrapped, reportTo) {
        super(wrapped, reportTo);
        this.wrapped_2 = wrapped;
        var tmp = this;
        var tmp0 = this.wrapped_2;
        var tmp_0 = KMutableProperty0();
        var tmp_1 = MutableReactiveValue$_get_value_$ref_6a9vml(tmp0);
        tmp.value$delegate_1 = getPropertyCallableRef('value', 0, tmp_0, tmp_1, MutableReactiveValue$_set_value_$ref_n0kkrz(tmp0));
      }
      set_value_v1vabv_k$(_set____db54di) {
        var tmp0 = this.value$delegate_1;
        var tmp = KMutableProperty1();
        var tmp_0 = RootMutableValidatedValue$_get_value_$ref_9j9rny();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('value', 1, tmp, tmp_0, RootMutableValidatedValue$_set_value_$ref_w6ztwm());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      get_value_j01efc_k$() {
        var tmp0 = this.value$delegate_1;
        var tmp = KMutableProperty1();
        var tmp_0 = RootMutableValidatedValue$_get_value_$ref_9j9rny();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('value', 1, tmp, tmp_0, RootMutableValidatedValue$_set_value_$ref_w6ztwm());
        return tmp0.get();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens_1;
    protoOf($).lens_u4wb4z_k$ = lens_2;
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    initMetadataForClass($, 'RootMutableValidatedValue', VOID, VOID, [MutableValidatedValue()], [1]);
    RootMutableValidatedValueClass = $;
  }
  return RootMutableValidatedValueClass;
}
var RootValidatedClass;
function RootValidated() {
  if (RootValidatedClass === VOID) {
    class $ {
      constructor(wrapped, reportTo) {
        this.wrapped_1 = wrapped;
        var tmp = this;
        var tmp1_elvis_lhs = reportTo == null ? null : reportTo.child$default_s9je3b_k$();
        tmp.node_1 = tmp1_elvis_lhs == null ? new (IssueNode())(null) : tmp1_elvis_lhs;
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      get_state_wc71uu_k$() {
        return this.wrapped_1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.wrapped_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.wrapped_1.beginUse_omrbby_k$();
      }
    }
    initMetadataForClass($, 'RootValidated', VOID, VOID, [Reactive()]);
    RootValidatedClass = $;
  }
  return RootValidatedClass;
}
var RootValidatedValueClass;
function RootValidatedValue() {
  if (RootValidatedValueClass === VOID) {
    class $ {
      constructor(wrapped, reportTo) {
        this.wrapped_1 = wrapped;
        var tmp = this;
        var tmp1_elvis_lhs = reportTo == null ? null : reportTo.child$default_s9je3b_k$();
        tmp.node_1 = tmp1_elvis_lhs == null ? new (IssueNode())(null) : tmp1_elvis_lhs;
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      get_value_j01efc_k$() {
        return this.wrapped_1.get_value_j01efc_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.wrapped_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.wrapped_1.beginUse_omrbby_k$();
      }
    }
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, 'RootValidatedValue', VOID, VOID, [ReactiveValue(), Reactive(), Listenable()]);
    RootValidatedValueClass = $;
  }
  return RootValidatedValueClass;
}
//region block: exports
export {
  validated as validatedmmpm5lnzq3lm,
  validated_0 as validated3dw9xce8adqbh,
};
//endregion

//# sourceMappingURL=entrypoints.mjs.map
